import './scss/style.scss';
import { domReady } from './js/domReady';
import initGalleryGrid from './js/gallery';
import { initMenuToggle } from './js/menu';
import { initUploadForm } from './js/upload';
import { initTitleScramble } from './js/titleScramble';

// Boot all front-end behaviors once the DOM is ready.
domReady(() => {
  initMenuToggle();
  initGalleryGrid();
  initUploadForm();
  initTitleScramble();
});
